import { createAction } from "redux-actions";

export const OUTREACH_LIST = "OUTREACH_LIST";
export const outReachList = createAction(OUTREACH_LIST);

export const OUTREACH_DETAILS = "OUTREACH_DETAILS";
export const outReachDetails = createAction(OUTREACH_DETAILS);

export const ADD_OUTREACH = "ADD_OUTREACH";
export const addOutreach = createAction(ADD_OUTREACH);

export const UPDATE_OUTREACH = "UPDATE_OUTREACH";
export const updateOutreach = createAction(UPDATE_OUTREACH);

export const DELETE_OUTREACH = "DELETE_OUTREACH";
export const deleteOutreach = createAction(DELETE_OUTREACH);
